var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "upload-queue-bar" }, [
    _c(
      "div",
      { staticClass: "queue-head" },
      [
        _c("w-fa", {
          staticClass: "queue-icon",
          attrs: { icon: "cloud-upload-alt" },
        }),
        _c("span", { staticClass: "queue-title" }, [_vm._v(_vm._s(_vm.title))]),
        _c("w-spacer"),
        _c("span", { staticClass: "queue-count" }, [
          _vm._v(
            _vm._s(
              _vm.$ct("x-of-y-done", {
                done: _vm.uploadJob.processedCount,
                total: _vm.uploadJob.files.length,
              })
            )
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "queue-files" },
      _vm._l(_vm.uploadJob.files, function (file, i) {
        return _c(
          "span",
          { key: i, staticClass: "queue-file", class: file.state },
          [
            file.state == "done"
              ? _c("w-fa", { attrs: { icon: "check" } })
              : file.state == "busy"
              ? _c("w-fa", { attrs: { icon: "circle-notch", spin: "" } })
              : _c("w-fa", { attrs: { icon: "clock" } }),
            _c("span", { staticClass: "queue-file-name" }, [
              _vm._v(_vm._s(file.name)),
            ]),
          ],
          1
        )
      }),
      0
    ),
    _c("div", { staticClass: "queue-bar" }, [
      _c("div", {
        staticClass: "queue-bar-fill",
        style: { width: _vm.uploadJob.progress + "%" },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }